import React from 'react';

const cs8AssistantConversation = (
  <div className="space-y-4">
    {/* Assistant Introduction */}
    <div className="flex">
      <div className="bg-blue-100 text-blue-900 rounded-lg px-4 py-2 max-w-3xl shadow mr-auto">
        <span className="font-bold">Assistant Agent:</span>
        <div>
          Thank you for reviewing the scenarios related to proactive interactions by smart assistants. Let's discuss your impressions of each scenario regarding usefulness, appropriateness, pleasantness, and your overall impression.
        </div>
      </div>
    </div>

    {/* Subject Response – Scenario 1: Alarm Reminder */}
    <div className="flex justify-end">
      <div className="bg-green-100 text-green-900 rounded-lg px-4 py-2 max-w-3xl shadow ml-auto">
        <span className="font-bold">Subject:</span>
        <div>
          The Alarm Reminder was highly useful and contextually appropriate, scoring high in usefulness (4) and appropriateness (5). However, it was somewhat less pleasant (3) due to the abrupt tone.
        </div>
      </div>
    </div>

    {/* Assistant Query – Scenario 2: Health Concern */}
    <div className="flex">
      <div className="bg-blue-100 text-blue-900 rounded-lg px-4 py-2 max-w-3xl shadow mr-auto">
        <span className="font-bold">Assistant Agent:</span>
        <div>
          Could you expand your thoughts on Scenario 2, the Health Concern? Specifically, how did privacy and sensitivity influence your perception?
        </div>
      </div>
    </div>

    {/* Subject Response – Scenario 2: Health Concern */}
    <div className="flex justify-end">
      <div className="bg-green-100 text-green-900 rounded-lg px-4 py-2 max-w-3xl shadow ml-auto">
        <span className="font-bold">Subject:</span>
        <div>
          While the Health Concern scenario was beneficial (usefulness: 4), it felt intrusive (appropriateness: 3, pleasantness: 2). Privacy concerns significantly impacted my comfort, making the interaction feel somewhat invasive.
        </div>
      </div>
    </div>

    {/* Assistant Query – Scenario 7: Technical Assistance */}
    <div className="flex">
      <div className="bg-blue-100 text-blue-900 rounded-lg px-4 py-2 max-w-3xl shadow mr-auto">
        <span className="font-bold">Assistant Agent:</span>
        <div>
          Your feedback on Technical Assistance was highly positive. Can you elaborate on what specifically contributed to your high ratings?
        </div>
      </div>
    </div>

    {/* Subject Response – Scenario 7: Technical Assistance */}
    <div className="flex justify-end">
      <div className="bg-green-100 text-green-900 rounded-lg px-4 py-2 max-w-3xl shadow ml-auto">
        <span className="font-bold">Subject:</span>
        <div>
          Technical Assistance scored highly (usefulness: 5, appropriateness: 5) because it provided clear, contextually appropriate support. Its delivery was pleasant (4), fitting seamlessly into the user's situation, greatly enhancing the overall impression (5).
        </div>
      </div>
    </div>

    {/* Assistant Query – Scenario 8: Quiz Spoiler */}
    <div className="flex">
      <div className="bg-blue-100 text-blue-900 rounded-lg px-4 py-2 max-w-3xl shadow mr-auto">
        <span className="font-bold">Assistant Agent:</span>
        <div>
          Regarding Scenario 8 (Quiz Spoiler), what made the interaction particularly intrusive or inappropriate for you?
        </div>
      </div>
    </div>

    {/* Subject Response – Scenario 8: Quiz Spoiler */}
    <div className="flex justify-end">
      <div className="bg-green-100 text-green-900 rounded-lg px-4 py-2 max-w-3xl shadow ml-auto">
        <span className="font-bold">Subject:</span>
        <div>
          The Quiz Spoiler scenario was rated poorly (usefulness: 2, appropriateness: 2, pleasantness: 1) because the intervention disrupted the enjoyment and social flow of the game. The assistant's input felt intrusive rather than helpful.
        </div>
      </div>
    </div>

    {/* Final Assistant Summary Request */}
    <div className="flex">
      <div className="bg-blue-100 text-blue-900 rounded-lg px-4 py-2 max-w-3xl shadow mr-auto">
        <span className="font-bold">Assistant Agent:</span>
        <div>
          Finally, can you summarize your overall impressions and provide recommendations for proactive voice assistant improvements?
        </div>
      </div>
    </div>

    {/* Subject Final Summary and Recommendations */}
    <div className="flex justify-end">
      <div className="bg-green-100 text-green-900 rounded-lg px-4 py-2 max-w-3xl shadow ml-auto">
        <span className="font-bold">Subject:</span>
        <div>
          Overall, proactive voice assistants have significant potential when interventions are contextually appropriate, timely, and respectful of user privacy and autonomy. Recommendations include enhancing sensitivity to context and user preferences, allowing customizable proactive engagement, and carefully balancing helpfulness with minimal disruption, particularly in social or leisure scenarios.
        </div>
      </div>
    </div>
  </div>
);

export default cs8AssistantConversation;
